









































































import { Component, Vue, Watch } from "@/shared/node_modules/vue-property-decorator";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import store from "@/shared/core/store";
import { coursePreviewToken, coursesApi, coursePreviewRoute } from "./coursePreview";
import InputText from "@/shared/components/form/inputText.vue";
import TextArea from "@/shared/components/form/textArea.vue";
import ProgramPage from "@/shared/components/programs/ProgramPage.vue";
import CourseLessons from "./courseLessons.vue";

@Component({ components: { InputText, TextArea, ProgramPage, CourseLessons } })
export default class CoursePage extends Vue {
  course: any = null;
  hasAccess: boolean = false;
  sections: any[] = [];
  progress: any[] = [];
  totalLessons: number = 0;
  completedLessons: number = 0;
  percentComplete: number = 0;
  allCourses: any[] = [];
  enrolledCourses: any[] = [];
  uploadsUrl: string = "";
  contact: any = { name: "", email: "", phone: "", message: "", website: "" };
  contactSending: boolean = false;
  contactSent: boolean = false;
  contactError: string = "";

  get customerId(): number {
    try {
      const raw = localStorage.getItem(window.location.host + "_cc");
      if (raw) { const p = JSON.parse(raw); const v = p.value || p; return (typeof v === "string" ? JSON.parse(v) : v).id; }
    } catch (e) {}
    return 0;
  }

  get previewToken(): string {
    return coursePreviewToken(this.$route);
  }

  get currentLesson(): any {
    const all = this.sections.flatMap((s: any) => s.lessons);
    for (const l of all) { if (this.getStatus(l.id) !== 2) return l; }
    return null;
  }

  get totalDurationSec(): number {
    return this.sections.flatMap((s: any) => s.lessons).reduce((t: number, l: any) => t + (l.durationSeconds || 0), 0);
  }

  get facts(): string {
    const bits: string[] = [];
    if (this.sections.length > 1) bits.push(this.sections.length + " " + this.$t("sections").toString());
    bits.push(this.totalLessons + " " + this.$t("lessons").toString());
    if (this.totalDurationSec) bits.push(this.formatDuration(this.totalDurationSec));
    if (this.hasAccess) bits.push(this.completedLessons + " " + this.$t("of").toString() + " " + this.totalLessons + " " + this.$t("completed").toString());
    return bits.join(" · ");
  }

  get otherCourses(): any[] {
    return this.allCourses.filter((c: any) => c.id !== this.course?.id);
  }

  async mounted() {
    this.uploadsUrl = store.state.settings?.Uploads || "";
    if (!this.previewToken) await this.loadAll();
    await this.loadCourse(this.$route.params.id);
  }

  @Watch("$route.params.id")
  async onRouteChange(id: string) { await this.loadCourse(id); }

  async loadAll() {
    const crud = new CrudService();
    const [allRes, myRes] = await Promise.all([
      crud.httpGet(`${Settings.HostName}/api/public-courses/list`),
      this.customerId
        ? crud.httpGet(`${Settings.HostName}/api/public-courses/my-courses`)
        : Promise.resolve(null)
    ]);
    this.allCourses = allRes?.data || [];
    this.enrolledCourses = myRes?.data || [];
  }

  async sendContact() {
    if (this.contactSending) return;
    this.contactError = "";
    this.contactSending = true;
    const res = await new CrudService().httpPost(`${Settings.HostName}/api/public-courses/contact/${this.course.id}`, this.contact);
    this.contactSending = false;
    if (res && res.ok) {
      this.contactSent = true;
      return;
    }
    this.contactError = res && res.rateLimited
      ? this.$t("Too many messages. Try again in a few minutes").toString()
      : (res && res.error) || this.$t("The message could not be sent").toString();
  }

  async loadCourse(courseId: string) {
    const data = await new CrudService().httpGet(coursesApi(courseId, this.previewToken));
    if (!data?.ok) return;
    this.course = data.course;
    this.hasAccess = data.hasAccess;
    this.sections = data.sections;
    this.progress = data.progress || [];
    this.totalLessons = data.totalLessons;
    this.completedLessons = data.completedLessons;
    this.percentComplete = data.percentComplete;
    window.scrollTo(0, 0);
  }

  getStatus(lessonId: number): number {
    const p = this.progress.find((x: any) => x.courseLessonId === lessonId);
    return p ? p.status : 0;
  }

  openLesson(lesson: any) {
    this.$router.push(coursePreviewRoute(`/courses/${this.course.id}/lessons/${lesson.id}`, this.previewToken));
  }

  pUrl(c: any): string {
    if (!c.poster) return "";
    return c.poster.startsWith("http") ? c.poster : this.uploadsUrl + "/" + c.poster;
  }

  formatDuration(s: number): string { return s ? Math.round(s / 60) + " min" : "0 min"; }
}
